import React from "react";
import { Button, Container, Row } from "react-bootstrap";

const Aims = () => {
  return (
    <>
      <section className="p-5 mx-md-5 ">
        <h1>Aims & Objective</h1>
        <Row className="mt-3">
          <p className="fs-6">
            1. To consider matter relating to the legal profession.
            <br />
            2. To promote high profession of one among the members of the
            profession.
            <br />
            3. To maintain and promote harmonious relating between the bench and
            the bar.
            <br />
            4. To repress unprofessional practices.
            <br />
            5. To render the assistance to members in cases of necessity.
            <br />
            6. To safeguard the civil liberties, fundamental and other rights of
            the citizens in general and of the legal profession in particular.
            <br />
            7. To arrange rendering legal assistance to persons, flot able to do
            themselves by giving them legal assistance by constituting legal and
            societies and otherwise.
            <br />
            8. To provide and maintain a common room, consultation room, a
            library, reading room and other amenities for the use and benefits
            of the members of the Association.
            <br />
            9. To associate itself with any work of humanitarian character or
            public benefit it considered desirable.
            <br />
            10. To promote generally the welfare of the Bar.
            <br />
            11. To discuss, express, represent and push its view on current
            topics of general welfare and public interest.
            <br />
            12. To seek affiliation with the Bar councils and other like codices
            <br />
          </p>
        </Row>
      </section>
    </>
  );
};

export default Aims;
